{
  "accepted": "Akseptert",
  "acceptTerms": "Aksepter vilkår",
  "accountSettings": "Kontoinnstillingar",
  "active": "Aktiv",
  "active_plural": "Aktive",
  "activity": "Aktivitet",
  "add": "Legg til",
  "addComment": "Legg til kommentar",
  "addCost": "Legg til kostnad",
  "addNote": "Legg til notat",
  "address": "Adresse",
  "all": "Alle",
  "alerts": "Varsler",
  "alreadyExists": "Eksisterar allereie",
  "amount": "Beløp",
  "applicantCompany": "Søkerbedrift",
  "approve": "Godkjenn",
  "approved": "Godkjent",
  "archive": "Arkiv",
  "ariaLabelReportSaveStatusSection": "Sist lagra status",
  "ariaLabelTopMenuSection": "Toppmeny",
  "attachment": "Vedlegg",
  "attachments": "Vedlegg",
  "back": "Tilbake",
  "background": "Bakgrunn",
  "baseInfo": "Basisinformasjon",
  "baseReport": "Basisrapport",
  "billingAddress": "Fakturaadresse",
  "budget": "Budsjett",
  "businessGarden": "Næringshage",
  "cancel": "Avbryt",
  "cannotBeUndone": "Denne handlinga kan ikkje endrast.",
  "cannotRead": "Du har ikkje leserettigheiter til dette.",
  "cannotWrite": "Du har ikkje skriverettigheiter til dette.",
  "caseNumber": "Saksnummer",
  "category": "Kategori",
  "choose": "Velg",
  "chooseActor": "Vel aktør",
  "chooseCluster": "Velg klynge",
  "chooseClusterChosen": "Vald nettverk",
  "chooseClusterTitle": "Velg klynge - Fleirbedriftsportalen",
  "chooseCounty": "Velg fylke",
  "chooseFiles": "Velg filer",
  "chooseReport": "Velg rapport",
  "chooseMunicipality": "Velg kommune",
  "chooseStatus": "Velg status",
  "chosenActor": "Vald aktør",
  "close": "Lukk",
  "closeDialog": "Lukk dialog",
  "textArea.charactersLeft": "%d teikn igjen",
  "textArea.charactersOver": "%d teikn for mykje",
  "jobTitle": "Stillingstittel",
  "cluster": "Klynge",
  "clusterLeader": "Leiar",
  "clusterManager": "Klyngeleiar",
  "boardChairman": "Styreleiar",
  "boardMember": "Styremedlem",
  "boardVaraMember": "Varamedlem, styre",
  "projectManager": "Prosjektleiar",
  "clusterName": "Nettverknamn",
  "clusterOperation": "Klyngedrift",
  "column": "Kolonne",
  "comment": "Kommentar",
  "commenting": "Kommenter",
  "company": "Bedrift",
  "completed": "Fullført",
  "contact": "Kontakt",
  "contactInformation": "Kontaktinformasjon",
  "contactPerson": "Kontaktperson",
  "contactStatus": "Kontaktstatus",
  "contactUsForSolution": "Kontakt oss gjerne for å finne ei anna løysing.",
  "continue": "Fortsett",
  "cooperation": "Samarbeid",
  "copyLink": "Kopier lenke",
  "cost": "Kostnadstype",
  "costs": "Kostnadar",
  "costType": "Kostnadstype",
  "costTypes": "Kostnadstypar",
  "costTypeTitle": "Tittel på kostnadstype",
  "count": "Antall",
  "county": "Fylke",
  "course": "Kurs",
  "create": "Opprett",
  "createAttachment": "Opprett vedlegg",
  "created": "Oppretta",
  "createReport": "Opprett rapport",
  "customer": "Kunde",
  "customerInfo": "Kundeinfo",
  "customerInformation": "Kundeinformasjon",
  "date": "Dato",
  "dateNotSet": "Dato ikkje satt",
  "default": "Standard",
  "delete": "Slett",
  "deleteSelected": "Slett valgte",
  "deleted": "Sletta",
  "deleting": "Slettar",
  "delivered": "Innsendt",
  "selfDeclarationStatusDeliveredOnDate": "Gyldig til {{date}}",
  "expiresSoon": "Utløper snart",
  "selfDeclarationExpired": "Utløpt",
  "selfDeclarationStatusExpiresOnDate": "Utløper {{date}}",
  "missing": "Manglar",
  "notApplicable": "Ikkje aktuelt",
  "description": "Beskriving",
  "developmentReport": "Utviklingsrapport",
  "done": "Ferdig.",
  "doNotSendEmail": "Ikkje send e-post",
  "download": "Last ned",
  "downloading": "Lastar ned",
  "downloadAttachment": "Last ned vedlegg",
  "downloadTemplate": "Last ned mal",
  "dragFiles": "eller drag dei hit.",
  "economy": "Økonomi",
  "edit": "Endre",
  "editTabelView": "Rediger tabellvising",
  "email": "E-post",
  "employee": "Ansatt",
  "emptyList": "Tøm lista",
  "end": "Avslutt",
  "endDate": "Sluttdato",
  "errorAcceptConsent": "Vi beklagar! Ein feil har skjedd internt i våre tjenester. Prøv gjerne ein gong til då det kan være ein midlertidig feil. Dersom problemet vedvarar, prøv igjen litt seinare.",
  "establishmentDate": "Etableringsdato",
  "event": "Event",
  "eventRegistration.completionGratitude": "Takk for at du registrerte deltakinga di!",
  "eventRegistration.errorRepeat": "Kunne ikkje sende inn registrering. Kan du prøve på nytt?",
  "eventRegistration.errorUnavailable": "Oppgitt event er ikkje tilgjengeleg for registrering.",
  "eventRegistration.formAddCompanyNameOrNumber": "Skriv in enten bedriftsnamn eller nummer. Hvis du ikkje finn det i lista som kjem opp kan du la navnet stå.",
  "eventRegistration.formAddContactInfo": "Legg inn kontaktinformasjon",
  "eventRegistration.formAdjustHours": "Justere timar",
  "eventRegistration.formAdjustHoursDescription": "Her kan du føre timar for reisetid og/eller forbereiande tmiar i tilleg til arrangementet. Timar brukt på arrangementet er allereie satt.",
  "eventRegistration.formDescriptionText": "Legg gjenre ved ein beskrivelse viss du endrar tidsbruket. Dette kan være for eksempel på grunn av reisetid, forbereingar eller anna.",
  "eventRegistration.formMyEmail": "Min e-post",
  "eventRegistration.formRegisterHours": "Registrer timar",
  "eventRegistration.formSendRegistration": "Send inn registrering",
  "eventRegistration.formTitle": "Registrer ditt oppmøte",
  "eventRegistration.title": "Eventregistrering",
  "export": "Eksporter",
  "exportToExcel": "Eksporter til Excel",
  "female": "Kvinne",
  "fetching": "Hentar...",
  "fetchingEvents": "Hentar events...",
  "fetchingHourRate": "Hentar timesats...",
  "fetchingProjects": "Hentar prosjekt...",
  "fieldIsRequired": "Dette feltet er påkrevd",
  "required": "Må fyllast ut",
  "fieldsOfInterest": "Interesseområder",
  "filter": "Filtrer",
  "filterBy": "Filtrer etter",
  "filterLeads": "Filtrer leads",
  "filterMembers": "Filtrer medlemmar",
  "filters": "Filter",
  "financing": "Finansiering",
  "financingSource": "Finansieringskjelde",
  "financingTitleLable": "Tittel på finansiering",
  "firstName": "Fornamn",
  "lastName": "Etternamn",
  "footer.contact": "Ta kontakt",
  "footer.copyright": "Opphavsrett © {{ date }}. Alle rettigheiter",
  "footer.questionsAboutPortal": "Spørsmål om fleirbedriftsportalen?",
  "from": "Frå",
  "gender": "Kjønn",
  "goalAchievement": "Måloppnåing",
  "goBack": "Gå tilbake",
  "gotoAdminStatistics": "Gå til admin-statistikk",
  "goToCourse": "Gå til kurs",
  "goToMainPage": "Gå til forsida",
  "halfYearReports": "Halvårsrapportar",
  "here": "her",
  "hide": "Skjul",
  "historic": "Historikk",
  "history": "Historie",
  "hits": "treff",
  "homeError4XX": "Noko feila i kommunikasjonen mellom våre tjenester. Vi kunne ikkje logge deg inn.",
  "homeError5XX": "Noko feila internt i våre system. Vi kunne ikkje logge deg inn.",
  "homeErrorContactLinkPart1": "Får du ikkje logga inn i portalen kan du ta kontakt med oss",
  "homeErrorContactLinkPart2": "eller sende oss ein mail på flerbedriftsportal@innovasjonnorge.no",
  "homeErrorNoActors": "Det ser ikkje ut som at du er knytta til ein aktør. For å kunne bruke Fleirbedriftsportalen må du ha blitt invitert inn av ein person hos ein aktør som har tilgang.",
  "homeErrorNotRegistered": "Det ser ut som om brukaren din ikkje er registrert. Kontakt ein aktør for å få aktiveringslenke.",
  "hours": "Timar",
  "imported": "Importert",
  "inactive": "Inaktiv",
  "inactive_plural": "Inaktive",
  "incubator": "Inkubator",
  "info": "Info",
  "inCollaboration": "I samarbeid",
  "inCollaborationWith": "I samarbeid med",
  "industry": "Bransje",
  "inkind": "Eigeninnsats",
  "innovationNorway": "Innovasjon Noreg",
  "inProgress": "I arbeid",
  "international": "Internasjonal",
  "invalid": "Ugyldeg",
  "invitationStatus": "Invitasjonsstatus",
  "keep": "Behald",
  "language": "Språk",
  "lastChanged": "Sist endra",
  "link": "Lenke",
  "linkCopied": "Lenke kopiert!",
  "loading": "Lastar",
  "loadingData": "Lastar data",
  "loadingAttachments": "Hentar vedlegg...",
  "tryAgain": "Prøv på nytt",
  "MulticompanyPortal": "Flerbedriftsportalen",
  "loadingMulticompanyPortal": "Laster inn fleirbedriftsportalen...",
  "loadingMulticompanyPortalClusters": "Henter klynger...",
  "loadingMulticompanyPortalPermissions": "Henter tilganger...",
  "loadingMulticompanyPortalRetrievingUser": "Henter brukar...",
  "loadingMulticompanyPortalTitle": "Laster inn Fleirbedriftsportalen",
  "location": "Lokasjon",
  "logIn": "Logg inn",
  "logInEmployee": "Ansatt i Innovasjon Noreg? Klikk her.",
  "logOut": "Logg ut",
  "mailingAddress": "Postadresse",
  "mainGoal": "Hovudmål",
  "mainMenu": "Hovudmeny",
  "header.contact": "Korleis kan vi hjelpe deg?",
  "maintenanceHeader": "Fleirbedriftsportalen er nede for vedlikehald",
  "maintenanceText": "Takk for tolmodet. Du kan nå oss på: ",
  "male": "Mann",
  "manually": "Manuelt",
  "memberCategories": "Medlemskategoriar",
  "memberSince": "Medlem sidan",
  "membersPerCounty": "Medlemmar per fylke",
  "memberTypes": "Medlemstypar",
  "min": "min",
  "missing": "Manglar",
  "mobile": "Mobil",
  "mobilePhone": "Mobiltelefon",
  "move": "Flytt",
  "moveDown": "Flytt ned",
  "moveUp": "Flytt opp",
  "multicompanyPortalWelcome": "Velkommen til fleirbedriftsportalen!",
  "municipality": "Kommune",
  "municipalityNumber": "Kommunenummer",
  "name": "Namn",
  "navbar.skipToContent": "Hopp til hovudinnhald",
  "new": "Ny",
  "newAttachment": "Nytt vedlegg",
  "next": "Neste",
  "nextPage": "Neste side",
  "no": "Nei",
  "noAccess": "Ingen adgang",
  "noAccessExplanation": "Du har ikkje adgang til denne sida. Vennlegst gå tilbake til forsida eller velg noko anna i menyen.",
  "noAttachments": "Ingen vedlegg",
  "noChangePermissions": "Du har ikkje tillatelse til å gjere endringar.",
  "noHits": "Ingen treff",
  "nonCounting": "Ikkje tellande",
  "none": "Ingen",
  "note": "Notat",
  "opensInNewTab": "Opnast i ny fane",
  "notVisible_plural": "Ikkje synlege",
  "numberOfEmployees": "Antal ansatte",
  "numberOfHours": "Antal timar",
  "numberOfMinutes": "Antal minutt",
  "numberOfParticipants": "Antal deltakarar",
  "of": "av",
  "ofTotal": "av totalt",
  "OK": "OK",
  "old": "Gammal",
  "oldestToNewest": "Eldste til nyast",
  "ongoing": "Pågåande",
  "operationResultListDescription": "{{ success }} blei fullført, og {{ errors }} feila. Vil du sjå detaljar?",
  "optional": "valfritt",
  "optionalCapitalized": "Valfritt",
  "organizationNumber": "Organisasjonsummer",
  "orgNr": "Org nr.",
  "other": "Anna",
  "overview": "Oversikt",
  "participants": "Deltakarar",
  "participatingCompany": "Deltakarbedrift",
  "pendingApproval": "Treng godkjenning",
  "phase": "Fase",
  "piece": "stykk",
  "piece_plural": "stykk",
  "postalCity": "Poststad",
  "previous": "Førre",
  "previousPage": "Førre side",
  "project": "Prosjekt",
  "project_one": "Prosjekt",
  "project_other": "Prosjekter",
  "projectTypes": "Prosjekttypar",
  "readTerms": "Eg har lest villkår for bruk og personvern.",
  "reason": "Grunn",
  "recommend": "Anbefal",
  "recommendedCourses": "Anbefalte kurs for medlemmar",
  "register": "Registrer",
  "registration": "Registrering",
  "registrationLink": "Registreringslenke",
  "remove": "Fjern",
  "removeSelected": "Gjern makrert utval",
  "reopen": "Gjenåpne",
  "reply": "Svar",
  "reports": "Rapportar",
  "reset": "Tilbakestill",
  "responsibility": "Ansvarsområde",
  "responsible": "Ansvarleg",
  "result": "Resultat",
  "retiermentDate": "Utmeldingsdato",
  "role": "Rolle",
  "roles": "Roller",
  "row": "Rad",
  "rowSelected": "Rad valt",
  "row_plural": "Rader",
  "rowsPerPage": "Rader per side",
  "rowsSelected": "Rader valt",
  "save": "Lagre",
  "saveAsPdf": "Lagre som PDF",
  "saving": "Lagrar...",
  "search": "Søk",
  "searchEmail": "Søk e-post",
  "searchForActor": "Søk etter aktør",
  "searchMobile": "Søk mobil",
  "searchName": "Søk namn",
  "searchNumberOfParticipants": "Søk antal deltakarar",
  "searchTelephone": "Søk telefon",
  "seeAll": "Sjå alle",
  "seeAllCompCenter": "Sjå alle i Kompetansesenteret",
  "seeMoreStats": "Sjå meir statistikk",
  "select": "Velg",
  "selectColumns": "Velg kolonner",
  "selectLanguage": "Velg språk",
  "selectYear": "Velg år",
  "send": "Send",
  "sendEmail": "Send e-post",
  "sent": "Sendt",
  "sentBack": "Sendt tilbake",
  "sessionExipredDescription": "Din sesjon er utløpt, for å få tilgang til portalen igjen må du logge inn på nytt.",
  "sessionExipredTitle": "Din sesjon er utløpt!",
  "shortCuts": "Snarvegar",
  "shortcuts": "Snarvegar",
  "show": "Vis",
  "showAll": "Vis alle",
  "showAllColumns": "Vis alle kolonner",
  "showDetails.hide": "Skjul detaljer",
  "showDetails.show": "Vis detaljer",
  "showEmailToggle.hide": "Skjul e-post",
  "showEmailToggle.show": "Vis e-post",
  "showFailed": "Vis feil",
  "showMore": "Vis meir",
  "showOnlySelected": "Vis berre valde",
  "showSucceeded": "Vis fullførte",
  "startCourse": "Start kurs",
  "startDate": "Startdato",
  "startup": "Oppstart",
  "statistics": "Statistikk",
  "statistics.noData": "Ingen data",
  "status": "Status",
  "submit": "Send inn",
  "sum": "Sum",
  "summary": "Samandrag",
  "surname": "Etternamn",
  "tasks": "Oppgåver",
  "telephone": "Telefon",
  "termsMustBeAccepted": "Beklager, du må godkjenne brukarvilkåra for å kunne logge inn i Fleirbedriftsportalen.",
  "termsOfUse": "Brukeravtale for Flerbedriftsportalen.",
  "timeRate": "Timesats",
  "toEnterYouMustApprove": "For å kome inn i fleirbedriftsportalen må du godkjenne",
  "toFrontpage": "Til forsida",
  "releaseNotes": "Nytt i Flerbedriftsportalen",
  "releaseNotes.useful": "Nyttig",
  "releaseNotes.voted": "stemte nyttig",
  "releaseNotes.seeAll": "Se all nytt",
  "total": "Total",
  "type": "Type",
  "unspecified": "Uspesifisert",
  "unsubscribe": "Meld ut",
  "unsubscribed": "Utmeld",
  "uploadFile": "Last opp fil",
  "userActivation.activationHeader": "Velkommen!",
  "userActivation.activationLoader": "Aktiverer portalinvitasjon. Vennlegst vent...",
  "userActivation.activationLoginRequest": "For å godta invitasjonen ber vi det logge inn gjennom id-porten.",
  "userActivation.activationTextDescription": "Fleirbedriftsportalen er ein plattform som tilbys klynger og nettverk. ",
  "userActivation.activationTextInvitation": "Du har blitt invitert til Flerbedriftsportalen til Innovasjon Norge. ",
  "userActivation.errorHeader": "Aktivering feila.",
  "userActivation.errorText": "Dette kan være på grunn av ugyldig aktiveringskode eller at du allereie er registrert.",
  "userActivation.title": "Brukaraktivering",
  "visible": "Synleg",
  "visible_plural": "Synlege",
  "website": "Nettstad",
  "withoutName": "Uten namn",
  "writeComplementary": "Skriv utfyllande",
  "writeHere": "Skriv her",
  "writeInDetail": "Skriv utfyllande",
  "writeInDetailMandatory": "Skriv utfyllande (obligatorisk)",
  "year": "År",
  "yes": "Ja",
  "zipCode": "Postnummer",
  "footer.innovasjonNorge.logo.altText": "Innovasjon Norge",
  "footer.declarityOfAvailability": "Tilgjengelegheitserklæring",
  "courses.recommendationSent": "Tenester er anbefalt!",
  "sending": "Sender...",
  "courses.sendRecommendation": "Send anbefaling",
  "courses.recommendCourse": "Anbefal kurs",
  "oneWayIn": "Én vei inn",
  "sivaReporting": "Rapportering til SIVA",
  "contactSupport": "Kontakt brukarstøtte",
  "contactUsByEmail": "Kontakt oss på e-post",
  "howCanWeHelp": "Du kan kontakte oss på følgjande e-post:",
  "showLess": "Vis mindre",
  "organization": "Organisasjon",
  "and": "og",
  "fromDate": "Fra dato",
  "frontpage.alerts.none": "Du har ingen nye varsler.",
  "toDate": "Til dato",
  "december": "Desember",
  "numberOfResults": "{{ resultsCount }} resultater funne",
  "noResults": "Søket ga ingen treff. Vennlegst prøv å bruke filter eller eit anna søkeord.",
  "actorTypes.cluster": "Klynger",
  "actorTypes.oneWayIn": "Ein veg inn",
  "actorTypes.sivaAdmin": "Siva admin",
  "step": "Steg",
  "monthly": "Månedtlig",
  "weekly": "Ukentlig",
  "never": "Aldri",
  "updateFailed": "Noe gikk galt",
  "notSet": "Ikkje satt",
  "readMore": "Les mer",
  "readLess": "Les mindre",
  "actors": "Aktørar",
  "sendResponse": "Send svar",
  "sendResponseAndRefer": "Send svar og gå til henvisning",
  "clusterStatus.OWI_ACTOR": "Én vei inn",
  "clusterStatus.INCUBATOR": "Inkubator",
  "clusterStatus.BUSINESS_GARDEN": "Næringshage",
  "clusterStatus.NIC_KLYNGE_2025": "Norwegian Innovation Cluster",
  "editTableView.tooltip": "Vel kolonnane som skal \nvisast i tabellen, og set \nrekkjefølgja på dei.",
  "draft": "Utkast",
  "seeMore": "Sjå meir",
  "seeLess": "Sjå mindre",
  "bold": "Fet",
  "italic": "Kursiv",
  "underline": "Understreket",
  "unorderedList": "Punktliste",
  "orderedList": "Nummerert liste",
  "getInContact": "Ta kontakt",
  "toTheTop": "Til toppen",
  "needHelp": "Treng du hjelp?",
  "subject": "Emne",
  "allInvoices": "Alle fakturaer",
  "byCompany": "Per bedrift",
  "invoicesAreReadyForImport": "Fakturaer er klar til import. Gjennomfør import med knappen nedenfor.",
  "invoicesImportedSuccessfully": "Fakturaer importert suksessfullt.",
  "allYears": "Alle år",
  "unknown": "Ukjent",
  "accessControl": "Tilgangsstyring",
  "advisor": "Rådgivar"
}
